export default __webpack_public_path__ + "static/media/1898.80268a5b.png";